import { StyleSheet } from 'react-native-unistyles';

import { theme } from '@squire/ui';

export const styles = StyleSheet.create((colors) => ({
  // Fullscreen scroll content: grows to fill so the button anchors at the bottom.
  centeredContent: {
    flexGrow: 1,
    alignItems: 'center',
    paddingHorizontal: theme.spacing[5],
    paddingVertical: theme.spacing[7],
  },
  // BottomSheet: natural height, content stacked with the button below.
  flowContent: {
    alignItems: 'center',
    paddingHorizontal: theme.spacing[5],
  },
  // Grows to fill in fullscreen, pushing the button to the bottom in flow.
  spacer: {
    flexGrow: 1,
  },
  avatarContainer: {
    marginBottom: theme.spacing[5],
    backgroundColor: colors.backgroundL1,
    alignSelf: 'center',
  },
  mainHeading: {
    textAlign: 'center',
    marginVertical: theme.spacing[3],
    paddingHorizontal: theme.spacing[10],
  },
  reviewInput: {
    height: 200,
    backgroundColor: colors.backgroundL0,
    borderColor: colors.borderPrimary,
    borderWidth: 1,
    borderRadius: theme.borderRadius.m,
    paddingHorizontal: theme.spacing[4],
    paddingVertical: theme.spacing[4],
    color: colors.textPrimary,
    fontSize: 16,
    lineHeight: 24,
    textAlignVertical: 'top',
    marginTop: theme.spacing[5],
  },
  // Shorter input for the compact BottomSheet variant.
  reviewInputCompact: {
    height: 120,
    alignSelf: 'stretch',
  },
  // In-flow, full-width action button (both variants).
  actionButton: {
    alignSelf: 'stretch',
    marginTop: theme.spacing[5],
  },
}));
